export default __webpack_public_path__ + "static/media/closeImg.5d6390e4.png";